import toast from "react-hot-toast";
import { post } from "./apiService";
import { API_URL } from "./apiUrl";

export const SendOtp = async (mobileNo, code = "+91") => {
    try {
        const response = await post(API_URL.SentOtp, {
            phone: mobileNo,
            code,
        });

        return response;
    } catch (error) {
        toast.error("Please try again after some time");
        return null;
    }
};

export const VerifyOTP = async (mobileNo, otp, guest_id, code = "+91") => {
    try {
        const response = await post(API_URL.verify_otp, {
            phone: mobileNo,
            otp: otp,
            guest_id: guest_id,
            code,
        });

        return response;
    } catch (error) {
        toast.error("Please try again after some time");
        return null;
    }
};

export const Register = async (formData) => {
    try {
        const response = await post(API_URL.register, formData);

        return response;
    } catch (error) {
        toast.error("Please try again after some time");
        return null;
    }
};